import { FigmaNodeRenderedImage, FigmaNodeRenderError, FigmaNodeRenderFormat, FigmaNodeRenderState, } from "../dsm";
import { z } from "zod";
export const ForgeProjectFigmaNode = z.object({
    id: z.string().uuid(),
    projectId: z.string(),
    sceneNodeId: z.string(),
    format: FigmaNodeRenderFormat,
    scale: z.number().optional(),
    renderState: FigmaNodeRenderState,
    renderedImage: FigmaNodeRenderedImage.optional(),
    renderError: FigmaNodeRenderError.optional(),
});
export const ForgeProjectFigmaNodeRenderInput = z.object({
    url: z.string(),
    format: FigmaNodeRenderFormat,
    scale: z.number(),
});
